export type ViewModeItem = {
    Value: string;
    Title: string;
    Icon: string;
}

export const ViewModeItems: ViewModeItem[] = [{
    Title: 'List View',
    Value: 'list',
    Icon: '/src/images/icons/list.svg'
}, {
    Title: 'Grid View',
    Value: 'grid',
    Icon: '/src/images/icons/grid.svg'
}];